import { IsCreditCard, Matches, MinLength } from 'class-validator';

import { creditCardExpirationRegexp, cvvRegexp } from '@onArte/shared/regexp';

export class CreditCardCreateModel {
  @MinLength(2)
  public name: string;

  @IsCreditCard()
  public cardNumber: string;

  @Matches(creditCardExpirationRegexp)
  public expiration: string;
  
  @Matches(cvvRegexp)
  public cvv: string;
}
